const classNames = (classes: {
  [key: string]: boolean | undefined
}): string | undefined => {
  const activeClasses = Object.keys(classes).filter((key) => classes[key])
  return activeClasses.length > 0 ? activeClasses.join(' ') : undefined
}

export default classNames
